module.exports = __webpack_public_path__ + "img/C100.58afe42b.png";